import { useRouter } from 'next/router';
import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { LoadingIndicator } from 'components/common';
import { ErrorPage } from 'components/error';
import { Page, PageContent, PageHeader } from 'components/page';
import { AchievementRender, AchievementRenderMultipleCompletions } from '.';

import type { GetAchievementsRes } from 'shared-types/responses';

interface Props {
  achievementId: number;
}

const Achievement = ({ achievementId }: Props) => {
  const { messages, user } = useReduxState();

  const { query } = useRouter();

  const { data, loading, updateData } = useApiData<GetAchievementsRes>({
    url:
      `/admin/achievements?type=single&id=${achievementId}` +
      (query.groupCompletionId
        ? `&groupCompletionId=${query.groupCompletionId}`
        : ''),
    onlyIf: Boolean(user) && Boolean(achievementId)
  });

  if (!achievementId || (!loading && !data?.achievements?.length)) {
    return <ErrorPage statusCode={404} />;
  }

  const achievement = data?.achievements[0];

  return (
    <Page activePathname="/achievements">
      <PageHeader simpleBack={true} title={messages.commonGoBack} />
      <PageContent>
        {loading ? (
          <LoadingIndicator />
        ) : achievement?.completions?.length > 1 ? (
          <AchievementRenderMultipleCompletions achievement={achievement} />
        ) : (
          <AchievementRender
            achievement={achievement}
            updateAchievement={updateData}
          />
        )}
      </PageContent>
    </Page>
  );
};

export default Achievement;
